import type { ReactNode } from "react";

/**
 * Плитка показателя для сводки руководителя (docs/07 §4: «4–6 метрик … читается за 30 секунд»).
 *
 * Вынесена из раздела «Претензии и риски», где такая карточка появилась первой: с E12 те же
 * цифры показывает директору сводка, и вторая вёрстка расходилась бы с первой шрифтом и тоном.
 * Только токены docs/07 — «сырых» hex нет (правило 9).
 */
export function Metric({
  title,
  value,
  caption,
  hint,
  risk = false,
}: {
  title: string;
  /** Главное число плитки — крупно, моноширинными цифрами. */
  value: ReactNode;
  /**
   * Расшифровка ГЛАВНОГО числа: без неё крупная цифра читается не тем, чем является
   * (например, «обязательств с начисленными санкциями» — это не «сейчас должны N»).
   */
  caption?: ReactNode;
  /** Пояснение простым языком: что эта цифра значит. */
  hint?: string;
  /** Тон риска: экспозиция и просрочки — красным, обычные показатели — цветом текста. */
  risk?: boolean;
}) {
  return (
    <div className="rounded-[var(--radius-l)] border border-border bg-surface p-3">
      <h3 className="text-[14px] font-bold text-ink">{title}</h3>
      <p className={`num mt-1 text-[22px] ${risk ? "text-overdue-fg" : "text-ink"}`}>{value}</p>
      {caption !== undefined && <p className="mt-1 text-[13px] text-muted">{caption}</p>}
      {hint !== undefined && <p className="mt-1 text-[12px] text-muted">{hint}</p>}
    </div>
  );
}
